






















































































































































































































































import {defineComponent, ref, watch} from '@nuxtjs/composition-api';
import type {PropType} from '@nuxtjs/composition-api';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {
  SfButton,
  SfLoader,
  SfLink,
  SfCheckbox,
} from '@storefront-ui/vue';
import Input from '~/components/Palmers/Input/Input.vue';
import Checkbox from '~/components/Palmers/Forms/Checkbox.vue';
import {required, email} from 'vee-validate/dist/rules';
import {customerPasswordRegExp, invalidPasswordMsg} from '~/modules/customer/helpers/passwordValidation';
import {customerInputRegExp, invalidTextMsg} from '~/modules/customer/helpers/inputTextValidation';
import {RegisterFormFields, FormName} from '~/components/Palmers/Forms/Register/types';
import {useUrl} from "~/composables/Palmers";

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('requiredcheckbox', {
  validate: value => !!value,
  message: 'This field is required\''
});

extend('required', {
  ...required,
  message: 'This field is required',
});

extend('password', {
  params: ['target'],
  validate: (value: string, {target}: Record<string, any>) => {
    if (!customerPasswordRegExp.test(value)) {
      return 'The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number, or one special character (E.g. , . _ & ? etc)';
    } else if (value !== target) {
      return 'Password confirmation does not match';
    }
    return true;
  }
});

extend('text', {
  params: ['target'],
  validate: (value: string) => {
    if (!customerInputRegExp.test(value)) {
      return invalidTextMsg;
    }
    return true;
  }
});

extend('nameField', {
  validate: (value) => /^[A-Za-zÄÖÜäöüß\s.'-]+$/u.test(value),
  message: 'Invalid characters used'
});

export default defineComponent({
  name: 'RegisterOnlineAccount',
  components: {
    Input,
    SfButton,
    Checkbox,
    SfLink,
    SfCheckbox,
    SfLoader,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    form: {
      type: Object as PropType<RegisterFormFields>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showRecaptcha: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {emit}) {
    const {getPageUrl} = useUrl();
    const formCopy = ref<RegisterFormFields>();
    watch(() => props.form, (newForm) => {
      formCopy.value = {...newForm};
    }, {immediate: true, deep: true});
    const changeForm = (formToNavigateTo: FormName) => {
      emit('change-form', formToNavigateTo);
    };

    return {
      getPageUrl,
      formCopy,
      changeForm,
    };
  },
});
